var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "elements"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 1.33331V2.66665M4 1.33331V2.66665",
    stroke: "#1C1C1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.66663 8.16216C1.66663 5.25729 1.66663 3.80486 2.50137 2.90243C3.33612 2 4.67962 2 7.36663 2H8.63329C11.3203 2 12.6638 2 13.4985 2.90243C14.3333 3.80486 14.3333 5.25729 14.3333 8.16216V8.5045C14.3333 11.4094 14.3333 12.8618 13.4985 13.7642C12.6638 14.6667 11.3203 14.6667 8.63329 14.6667H7.36663C4.67962 14.6667 3.33612 14.6667 2.50137 13.7642C1.66663 12.8618 1.66663 11.4094 1.66663 8.5045V8.16216Z",
    stroke: "#1C1C1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 4046",
    d: "M2 5.33331H14",
    stroke: "#1C1C1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElements);
export default __webpack_public_path__ + "static/media/elements.8dd98da8beb3378b254c9c6af1f46b94.svg";
export { ForwardRef as ReactComponent };